import { render, staticRenderFns } from "./bookingSetting.vue?vue&type=template&id=2f74a261&scoped=true"
import script from "./bookingSetting.vue?vue&type=script&lang=js"
export * from "./bookingSetting.vue?vue&type=script&lang=js"
import style0 from "./bookingSetting.vue?vue&type=style&index=0&id=2f74a261&prod&lang=less&scoped=true"
import style1 from "./bookingSetting.vue?vue&type=style&index=1&id=2f74a261&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f74a261",
  null
  
)

export default component.exports